export type ValidityHtmlElement = React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
  valid: boolean;
  hasFocus: boolean;
  noValid?: boolean;
  invalid?: boolean;
  errorMessage?: string;
  defaultErrorMessage?: string;
  assignValidity: () => void;
  checkComboValidity: () => void;
  evaluateCustomValidity: () => void;
};

export type SideMenuHtmlElement = React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
  selectedISecondarytem?: string;
  propertyEvaluateToSelectItem?: string;
  config?: unknown;
};

export type FraudnetHtmlElement = React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;

export type BaseDsguidlines = React.HTMLAttributes<HTMLElement>;

//Side Menu type
export enum StepFamily {
  ABOUT = 'À propos de vous',
  SUMMARY = 'Votre récapitulatif',
  RESPONSE = 'Notre réponse',
}

export type SideMenuData = { [key in StepFamily]: SideMenuDataItem };

export interface SideMenuDataItem {
  icon: string;
  displaySecondaryMenu: boolean;
  items: SideMenuDataSecondaryItem[];
  state: SIDEMENUSTATE;
}

export interface SideMenuDataSecondaryItem {
  label: string;
  url: string;
  state: SIDEMENUSTATE;
  order: number;
}

export enum SIDEMENUSTATE {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  SELECTED = 'selected',
}

export enum ICON {
  SUMMARY = 'coins',
  ABOUT = 'personMatrix',
  INSURANCE = 'parapluie',
  RESPONSE = 'checkCircleMatrix',
}
